import { format } from 'date-fns';
import styled from 'styled-components';

interface DayViewColumnProps {
  date: Date;
}

export default function DayViewColumn({ date }: DayViewColumnProps) {
  const dayName = format(date, 'EEEE');
  const dayNumber = format(date, 'd');

  return (
    <Column data-cy={`day-view-column-${format(date, 'yyyy-MM-dd')}`}>
      <DayHeader>
        <DayName>{dayName}</DayName>
        <DayNumber>{dayNumber}</DayNumber>
      </DayHeader>
      <DayContent>{/* Patient cards will be rendered here in future */}</DayContent>
    </Column>
  );
}

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 500px;
`;

const DayHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px 8px;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 4px;
`;

const DayName = styled.span`
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black};
`;

const DayNumber = styled.span`
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black};
  line-height: 1;
`;

const DayContent = styled.div`
  flex: 1;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  overflow-y: auto;
`;
